import {commonControllers} from '@mintdata-wsp/common/controllers/CommonControllers';
import {PropBinding} from '@mintdata-wsp/common/state/ui/visualDesigner/surface/binding/Binding';
import {IHostContext} from '@mintdata-wsp/common/state/ui/visualDesigner/surface/HostContext';
import {Prop} from '@mintdata-wsp/common/state/ui/visualDesigner/surface/property/Prop';
import {Repeater} from '@mintdata-wsp/common/state/ui/visualDesigner/surface/property/repeater/Repeater';
import {BindingId} from '@mintdata/mint-kit/api/models/Identifiers';
import {PropPath} from '@mintdata/mint-kit/api/properties/PropPath';

export class HostContextController implements IHostContext
{
    public init()
    {
        Prop.HOST_CONTEXT = this;
    }

    public getPropBinding(bindingId:BindingId):PropBinding
    {
        return commonControllers.bindings.getPropBinding(bindingId);
    }

    public getPropBoundValue<T>(prop:Prop<T>, binding:PropBinding, repeater:Repeater):any
    {
        return commonControllers.bindings.getPropBoundValue(prop, binding, repeater);
    }

    public onPropValueChanged(prop:Prop<any>, propPath:PropPath, newValue:any, oldValue:any):void
    {
        // handle hostId renaming
        commonControllers.designState.changeBoxesHostIdOnPropChange(prop, propPath, newValue, oldValue);
    }

    public onPropArrayItemMoved(prop:Prop<any>, propPath:PropPath, indexFrom:number, indexTo:number)
    {
        // move all related bindings
        commonControllers.bindings.moveBindingsOnPropArrayItemMoved(prop, propPath, indexFrom, indexTo);
    }

    public onPropArrayItemRemoved(prop:Prop<any>, propPath:PropPath, index:number):void
    {
        // remove children from removed host, if item was remove from container property
        commonControllers.designState.removeHostOnPropArrayItemRemoved(prop, propPath, index);

        //remove all related bindings
        commonControllers.bindings.removeBindingsOnPropArrayItemRemoved(prop, propPath, index);
    }
}
